import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Spin } from "antd";
import '../App.css';
import { routes } from '../const';
import KuehModal from "../components/KuehModal";
import { getAllTasks } from "../tasks";

export default function TaskSelection() {
    // for kueh modal
    const [ visible, setVisible ] = useState(false);
    const [ loading, setLoading ] = useState(true);
    const [ tasks, setTasks ] = useState([]);

    useEffect(() => {
        document.body.style.overflow = "hidden"; // prevent scrolling
        document.body.style.backgroundColor =' #a7c7e7';

        getAllTasks()
            .then(data => {
                if (data) {
                    setTasks(data);
                } else {
                    // TODO: what to display here
                }
                setLoading(false);
            });
    }, []);

    const showModal = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        setVisible(false);
    };

    return (
        <div className='story flex flex-col-reverse relative' style={{ backgroundImage: "url(/kueh-shop-transparent.jpg)"}}>

            <div className="basis-1/4 p-8 relative bg-emerald-600 mt-4" >

                <p className="text-3xl text-white font-bold text-center">Select a task to get started!</p>

            </div>


            <Link to={ routes.POST_SURVEY } className="text-center">
                <button className=" bg-slate-600 hover:bg-slate-700 text-white py-2 px-10 rounded-full text-xl ">End session</button>
            </Link>
            

            <div className="basis-1/2 flex-col m-4" >
            <Spin className="mx" size="large" tip="Loading..." spinning={loading} >
                { tasks.map((t, i) => (
                    <Link key={i} to={routes.TASK.replace(":task", t.id)} onClick={ () => window.sessionStorage.removeItem("log") } >
                        <div className="h-24 mb-6 bg-white p-4 rounded-lg flex justify-center ">
                            <p className="text-center text-xl text-wrap">{t.fullName}</p>
                        </div>
                    </Link>
                ))}
            </Spin>
            </div>

            <div className="absolute top-4 right-4 w-16 bg-slate-200 p-2 rounded-md">
                <img src="/kueh/lapis.png" alt="collected kueh" onClick={showModal} />
            </div>
            <KuehModal
                title="Collected Kueh"
                visible={visible}
                onCancel={handleCancel}
                footer={null}
                width={1000}
                tasks={tasks}
            />

        </div>
            
    );
}